// Add General Info Page
export const GET_NOTIFICATIONS_ALL = "GET_NOTIFICATIONS";
export const GET_NOTIFICATIONS_BYDATES = "GET_NOTIFICATIONS_BYDATES";
export const GET_NEW_NOTIFICATIONS_ALL = "GET_NEW_NOTIFICATIONS";
